import { render } from "./DeleteMember.vue?vue&type=template&id=67e9c5a5&scoped=true"
import script from "./DeleteMember.vue?vue&type=script&lang=js"
export * from "./DeleteMember.vue?vue&type=script&lang=js"

import "./DeleteMember.vue?vue&type=style&index=0&id=67e9c5a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e9c5a5"]])

export default __exports__